import Moment from 'moment';

export function formatDobInput(value) {
  const digits = String(value || '').replace(/\D/g, '').slice(0, 8);

  if (digits.length <= 2) {
    return digits;
  }

  if (digits.length <= 4) {
    return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  }

  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
}

export function formatDobDisplay(value) {
  if (!value) {
    return '';
  }

  const normalized = String(value).trim();

  if (/^\d{2}\/\d{2}\/\d{4}$/.test(normalized)) {
    return normalized;
  }

  if (/^\d{2}-\d{2}-\d{4}$/.test(normalized)) {
    return normalized.replace(/-/g, '/');
  }

  const digits = normalized.replace(/\D/g, '');
  if (digits.length === 8) {
    return formatDobInput(digits);
  }

  return formatDobInput(normalized);
}

export function dobToApiFormat(value) {
  const display = formatDobDisplay(value);
  if (!display) {
    return '';
  }

  const [month, day, year] = display.split('/');
  return `${month}-${day}-${year}`;
}

export function formatCardExpInput(value) {
  const digits = String(value || '').replace(/\D/g, '').slice(0, 4);

  if (digits.length <= 2) {
    return digits;
  }

  return `${digits.slice(0, 2)}/${digits.slice(2)}`;
}

export function formatCardExpDisplay(value) {
  if (!value) {
    return '';
  }

  const normalized = String(value).trim();
  if (/^\d{2}\/\d{2}$/.test(normalized)) {
    return normalized;
  }

  const digits = normalized.replace(/\D/g, '');
  if (digits.length === 4) {
    return formatCardExpInput(digits);
  }

  return formatCardExpInput(normalized);
}

export function isCardExpComplete(value) {
  return cardExpToApiFormat(value).length === 4;
}

export function isDobComplete(value) {
  return /^\d{2}\/\d{2}\/\d{4}$/.test(formatDobDisplay(value));
}

export function cardExpToApiFormat(value) {
  return String(value || '').replace(/\D/g, '').slice(0, 4);
}

export function parseCardExp(value) {
  const digits = cardExpToApiFormat(value);
  if (digits.length !== 4) {
    return null;
  }

  const month = parseInt(digits.slice(0, 2), 10);
  const year = 2000 + parseInt(digits.slice(2, 4), 10);

  if (month < 1 || month > 12) {
    return null;
  }

  return { month, year };
}

export function getCardExpEndDate(value) {
  const parsed = parseCardExp(value);
  if (!parsed) {
    return null;
  }

  return Moment({ year: parsed.year, month: parsed.month - 1 }).endOf('month');
}

export function isCardExpExpired(value) {
  const endDate = getCardExpEndDate(value);
  if (!endDate) {
    return false;
  }

  return endDate.isBefore(Moment(), 'day');
}

export function isCardExpiringSoon(value, months = 6) {
  const endDate = getCardExpEndDate(value);
  if (!endDate || isCardExpExpired(value)) {
    return false;
  }

  return endDate.isSameOrBefore(Moment().add(months, 'months'), 'day');
}

export function isCardExpValid(value) {
  return isCardExpComplete(value) && parseCardExp(value) !== null && !isCardExpExpired(value);
}
